







































































































import Draggable from 'vuedraggable';
import TinySlider from 'vue-tiny-slider';
import GridButtonAddRow from './GridButtonAddRow.vue';
import GridButtonAddColumn from './GridButtonAddColumn.vue';
import GridColumn from './GridColumn.vue';
import GridRow from './GridRow.vue';

export default {
  props: {
    value: [Array, Object],
    canAddColumn: Boolean,
    canAddRow: Boolean,
    canReorder: Boolean,
    canEdit: Boolean,
    shape: [Array, Object],
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: this.$store.state.isMobile,
    };
  },
  computed: {
    localValue: {
      get(): string {
        return this.value;
      },
      set(value: string) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    removeRow(rowIndex: number) {
      this.localValue = [
        ...this.value.slice(0, rowIndex),
        ...this.value.slice(rowIndex + 1),
      ];
    },
  },
  components: {
    Draggable,
    GridButtonAddRow,
    GridButtonAddColumn,
    GridColumn,
    GridRow,
    TinySlider,
  },
} as IView;
